"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = registerService;
exports.WEBPACK_3_FORCE_MODULE_IMPORT = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

function registerService(initialState, handlers) {
  var dispatcher = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _dispatcher.default;
  var state = initialState;

  function runService(_ref) {
    var actionType = _ref.actionType,
        data = _ref.data;

    if (Object.prototype.hasOwnProperty.call(handlers, actionType)) {
      state = handlers[actionType](state, data, actionType);
    }
  }

  var dispatcherId = dispatcher.register(runService);
  return {
    dispatcherId: dispatcherId,
    getState: function getState() {
      return state;
    },
    handlers: handlers,
    initialState: initialState,
    runService: runService,
    unregister: function unregister() {
      return dispatcher.unregister(dispatcherId);
    }
  };
}

var WEBPACK_3_FORCE_MODULE_IMPORT = 1;
exports.WEBPACK_3_FORCE_MODULE_IMPORT = WEBPACK_3_FORCE_MODULE_IMPORT;